
import { defineComponent, SetupContext, PropType } from "vue";
import ApplianceList from "@/components/search/ApplianceList.vue";
import { ApplianceData } from "@/types/search";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "ApplianceDialog",
  components: { ApplianceList },
  props: {
    /** ダイアログのアクティブ状態 (true: 活性、false: 非活性) */
    showDialog: {
      type: Boolean,
      default: false
    },
    /**
     * 機器リストに表示するデータの配列
     */
    list: {
      type: Array as PropType<ApplianceData[]>,
      default: () => []
    }
  },
  setup(props, context: SetupContext) {
    const onClickClose = () => {
      context.emit("close-click");
    };

    const getList = () => {
      return props.list;
    }

    const selectCheck = (id: number, checked: boolean) => {
      NativeClient.sendDebugLog("ApplianceDialog selectCheck id=" + id + " checked=" + checked);
      context.emit("select-check", id, checked);
    };

    const isShowList = () => {
      return props.list != null && props.list.length != 0;
    };

    const onClickPositive = () => {
      context.emit("positive-click");
    };

    return {
      onClickClose,
      onClickPositive,
      getList,
      selectCheck,
      isShowList
    };
  }
});
